class Collapse {
    constructor(node) {
        this.wrap = node.closest('.collapse');
        this.toggle = this.wrap.querySelector('.collapse__toggle');
        this.body = this.wrap.querySelector('.collapse__body');
        this.useMaxHeight = this.wrap.classList.contains('collapse_max-h');
    }

    get collapsed() {
        return this.wrap.classList.contains('collapse_collapsed');
    }

    get bodyTransition() {
        return parseFloat(getComputedStyle(this.body).transitionDuration);
    }

    expand() {
        if (this.useMaxHeight) {
            this.wrap.classList.remove('collapse_collapsed');
            this.body.style.overflow = 'hidden';
            this.body.style.maxHeight = this.body.scrollHeight + 'px';

            this.onBodyTransition(() => {
                this.body.style.overflow = null;
            })
        } else {
            this.wrap.classList.remove('collapse_collapsed');
            this.body.style.height = this.body.scrollHeight + 'px';

            this.onBodyTransition(() => {
                this.body.style.height = null
            });
        }
        
    }

    onBodyTransition(cb) {
        const onTransitionEnd = () => {
            cb();
            this.body.removeEventListener('transitionend', onTransitionEnd);
        }

        if (this.bodyTransition) {                  
            this.body.addEventListener("transitionend", onTransitionEnd);
        } else {
            cb();
        }
    }

    collapse() {
        if (this.useMaxHeight) {
            this.body.style.maxHeight = null;
            this.wrap.classList.add('collapse_collapsed');
        } else {
            this.body.style.height = this.body.clientHeight + 'px';
            this.body.offsetHeight;
            this.wrap.classList.add('collapse_collapsed');
            this.body.style.height = 0;
        }
    }
}

export default new (class {
    constructor() {
        document.querySelectorAll('.collapse_max-h').forEach(item => {
            const collapse = new Collapse(item);
            if (collapse.body.clientHeight > collapse.body.scrollHeight - 5) {
                collapse.toggle.style.display = 'none';
            }
            console.log(item.querySelector('.collapse__body').scrollHeight, item.querySelector('.collapse__body').clientHeight)
        })
        document.body.addEventListener('click', (e) => {
            if (e.target.closest('.collapse__toggle')) {
                const collapse = new Collapse(e.target);

                if (collapse.collapsed) {
                    collapse.expand();
                } else {
                    collapse.collapse();
                }
            }
        })
    }
})();
